import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminClients_idSend_password_reset_email = z.any()
export type TagsPostAdminClients_idSend_password_reset_email = z.infer<typeof tagsPostAdminClients_idSend_password_reset_email>

export const paramsPostAdminClients_idSend_password_reset_email = z.object({ "id": z.string() })
export type ParamsPostAdminClients_idSend_password_reset_email = z.infer<typeof paramsPostAdminClients_idSend_password_reset_email>

export const responsePostAdminClients_idSend_password_reset_email = z.any()
export type ResponsePostAdminClients_idSend_password_reset_email = z.infer<typeof responsePostAdminClients_idSend_password_reset_email>

interface IPostAdminClients_idSend_password_reset_email extends BaseMethodType {
  tags: TagsPostAdminClients_idSend_password_reset_email,
  params: ParamsPostAdminClients_idSend_password_reset_email,
  response: ResponsePostAdminClients_idSend_password_reset_email
}
export const URL = '/admin/clients/:id/send-password-reset-email'
export const validation = {
  post: {
    tags: tagsPostAdminClients_idSend_password_reset_email,
    params: paramsPostAdminClients_idSend_password_reset_email,
    response: responsePostAdminClients_idSend_password_reset_email
  }
}
export interface AdminClients_idSend_password_reset_email extends BaseRouteType {
  post: IPostAdminClients_idSend_password_reset_email
}